(() => {
  function init() {
    document.querySelectorAll('[data-video-target]').forEach(button => {
      if (button.dataset.ready) return;
      const video = document.getElementById(button.dataset.videoTarget);
      if (!video) return;
      button.dataset.ready = 'true';
      const sync = () => { button.hidden = !video.paused && !video.ended; };
      video.addEventListener('playing', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', () => { button.hidden = false; video.controls = true; });
      button.addEventListener('click', () => {
        const source = video.querySelector('source[data-src]');
        if (source) { source.src = source.dataset.src; delete source.dataset.src; video.load(); }
        if (video.dataset.poster) { video.poster = video.dataset.poster; delete video.dataset.poster; }
        video.muted = true;
        video.play().catch(() => { button.hidden = false; video.controls = true; });
      });
      sync();
      if (video.autoplay && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.play().catch(() => { button.hidden = false; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
